import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { HeadingText30 } from '../Typography/Typography';
import * as styles from './RadioGroup.module.scss';
import { Radio } from './Radio';
let idcounter = 0;
const generateGroupName = () => `radio-group-${++idcounter}`;
/**
 * @deprecated
 */
export const RadioGroup = ({ legend, onChange, options, groupName, testID, ...props }) => {
    const [internalGroupName, setInternalGroupName] = React.useState(groupName || '');
    React.useEffect(() => {
        setInternalGroupName(groupName || generateGroupName());
    }, [groupName]);
    const onChangeValue = (_, value) => {
        onChange(value);
    };
    return (_jsxs("fieldset", { className: styles.container, "data-testid": testID, children: [legend !== undefined ? (_jsx("legend", { className: styles.legend, children: typeof legend === 'string' ? (_jsx(HeadingText30, { as: "span", children: legend })) : (legend) })) : null, _jsx("div", { className: styles.options, children: options.map(({ label, value }) => (_jsx(Radio, { label: label, value: value, groupName: internalGroupName, onChange: onChangeValue, ...('selected' in props
                        ? { isSelected: value === props.selected }
                        : {}) }, `radio-option-${value}`))) })] }));
};
